import { Accordion } from '@/components/ui/accordion'
import FcaTimelineItem from '@/components/shared/claim-updates/FcaTimelineItem'
import { fcaTimelineData } from '@/data/fcaTimelineData'

const FcaTimeline = () => (
  <div
    id="fca-timeline"
    className="border-border/60 scroll-mt-24 overflow-hidden rounded-xl border shadow-sm"
  >
    <div className="bg-foreground px-5 py-3">
      <h2 className="text-sm font-bold tracking-wider text-white uppercase">
        FCA news timeline
      </h2>
    </div>
    <div className="bg-card p-5 sm:p-6">
      <Accordion type="single" collapsible className="w-full">
        {fcaTimelineData.map((item, index) => (
          <FcaTimelineItem
            key={item.id}
            item={item}
            isFirst={index === 0}
            isLast={index === fcaTimelineData.length - 1}
          />
        ))}
      </Accordion>
    </div>
  </div>
)

export default FcaTimeline
